import { make } from "vuex-pathify";
import { getAPI, postAPI, getDownloadAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {
    retrieveCampaigns({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveCampaigns" , filter).then((res) => {
            return res;
        })
        .finally(function () {
            commit("SET_LOADING", false);
        });
    },

    retrieveAllCampaigns({ commit }) {
      commit("SET_LOADING", true);
      return getAPI("campaign/retrieveAllCampaignsMin").then((res) => {
          return res;
      })
      .finally(function () {
          commit("SET_LOADING", false);
      });
  },

    retrieveCropProductions({ commit }, campaignId) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveCropProductions" , {id: campaignId })
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveCropProductionById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveCropProductionById" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveFieldLots({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveFieldLots" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteCropProduction({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("campaign/deleteCropProduction/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveMeasurements({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveMeasurements" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveCampaign({ commit }, campaign) {
        commit("SET_LOADING", true);
        return postAPI("campaign/saveCampaign", campaign).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveCropProduction({ commit }, cropProduction) {
        commit("SET_LOADING", true);
        return postAPI("campaign/saveCropProduction", cropProduction).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveEstimateProduction({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveEstimateProduction").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveDestinations({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveDestinations").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveProjects({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveProjects").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteCampaign({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("campaign/deleteCampaign/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveCampaignById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveCampaignById" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      exportExcelProductions({ commit } , filter) {
        commit("SET_LOADING", true);
        return getDownloadAPI("campaign/exportExcelProductions" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      activateCampaign({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("campaign/activateCampaign" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveCountries({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveCountries").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveFilteredProductions({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("campaign/retrieveFilteredProductions" , filter).then((res) => {
            return res;
        })
        .finally(function () {
            commit("SET_LOADING", false);
        });
    },

    countCampaigns({ commit }) {
      commit("SET_LOADING", true);
      return getAPI("campaign/count").then((res) => {
        return res;
      })
        .finally(function () {
          commit("SET_LOADING", false);
        });
    },

    countCropProductions({ commit }, filter) {
      commit("SET_LOADING", true);
      return getAPI("campaign/countCropProductions", filter).then((res) => {
        return res;
      })
        .finally(function () {
          commit("SET_LOADING", false);
        });
    },
};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };